// src/hooks/usePageVisibility.js
import { useState, useEffect } from 'react';

export const usePageVisibility = () => {
  const [isVisible, setIsVisible] = useState(!document.hidden);
  const [visibilityState, setVisibilityState] = useState(document.visibilityState);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(!document.hidden);
      setVisibilityState(document.visibilityState);
      
      console.log('👁️ Page visibility changed:', {
        isVisible: !document.hidden,
        state: document.visibilityState,
        timestamp: new Date().toISOString()
      });
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return { 
    isVisible, 
    visibilityState,
    isHidden: !isVisible 
  };
};